import styled from '@independent-software/typeui/styles/Theme'

const Content = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  flex: 1;  
`

export { Content }